var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0735 10.4435C19.0735 12.0632 18.5932 13.6466 17.6934 14.9934C16.7935 16.3401 15.5144 17.3898 14.018 18.0097C12.5215 18.6295 10.8749 18.7917 9.28627 18.4757C7.69765 18.1597 6.2384 17.3797 5.09307 16.2344C3.94774 15.089 3.16776 13.6298 2.85176 12.0412C2.53576 10.4526 2.69795 8.80591 3.31779 7.30947C3.93764 5.81302 4.98732 4.53398 6.33409 3.6341C7.68086 2.73422 9.26423 2.25391 10.884 2.25391C13.056 2.25391 15.139 3.11673 16.6749 4.65258C18.2107 6.18842 19.0735 8.27147 19.0735 10.4435Z",
    stroke: "#424450",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9219 13.0478L11.3815 11.5331C11.1491 11.3758 10.9562 11.1669 10.818 10.9226C10.6797 10.6784 10.5998 10.4055 10.5845 10.1253V6.76562",
    stroke: "#424450",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuration);
export default __webpack_public_path__ + "static/media/duration.3b6625a5880f9030ad7da70526f083c4.svg";
export { ForwardRef as ReactComponent };